import { useTranslation } from "react-i18next";
import type { ReactNode } from "react";
import { Tabs, TabsList, TabsPanel, TabsTab } from "@/components/ui/tabs";

export type UploadInputMode = "file" | "text" | "url";

interface UploadInputModeTabsProps {
  inputMode: UploadInputMode;
  isUploading: boolean;
  onInputModeChange: (mode: UploadInputMode) => void;
  filePanel: ReactNode;
  textPanel: ReactNode;
  urlPanel: ReactNode;
}

export default function UploadInputModeTabs({
  inputMode,
  isUploading,
  onInputModeChange,
  filePanel,
  textPanel,
  urlPanel,
}: UploadInputModeTabsProps) {
  const { t } = useTranslation(["upload"]);

  return (
    <Tabs
      value={inputMode}
      onValueChange={(value) => onInputModeChange(value as UploadInputMode)}
    >
      <div className="mb-6 flex justify-center">
        <TabsList aria-label={t("upload:uploadDocument")}>
          <TabsTab
            value="file"
            id="input-mode-file"
            disabled={isUploading}
            data-test="input-mode-file"
          >
            {t("upload:inputMode.file")}
          </TabsTab>
          <TabsTab
            value="text"
            id="input-mode-text"
            disabled={isUploading}
            data-test="input-mode-text"
          >
            {t("upload:inputMode.text")}
          </TabsTab>
          <TabsTab
            value="url"
            id="input-mode-url"
            disabled={isUploading}
            data-test="input-mode-url"
          >
            {t("upload:inputMode.url")}
          </TabsTab>
        </TabsList>
      </div>

      <TabsPanel value="file" data-test="file-upload-panel">
        {filePanel}
      </TabsPanel>
      <TabsPanel value="text" data-test="text-input-panel">
        {textPanel}
      </TabsPanel>
      <TabsPanel value="url" data-test="url-input-panel">
        {urlPanel}
      </TabsPanel>
    </Tabs>
  );
}
